export default "__VITE_ASSET__mnFywovV__"